<template>
  <input type="date" class="input" :value="modelValue" @input="handleInput" :disabled="disabled" :max="computedMaxDate"
    :min="computedMinDate" />
</template>

<script>

export default {
  name: 'InputDate',
  props: {
    modelValue: {
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: String,
      default: null
    },
    maxDate: {
      type: String,
      default: null
    }
  },
  computed: {
    computedMinDate() {
      return this.minDate || '1900-01-01'
    },
    computedMaxDate() {
      return this.maxDate || '9999-12-31'
    }
  },
  methods: {
    handleInput(event) {
      let value = event.target.value

      if (value && value.length === 10) {
        const year = value.substring(0, 4)

        if (year.length === 4 && /^\d{4}$/.test(year)) {
          const yearNum = parseInt(year)
          if (yearNum >= 1900 && yearNum <= 9999) {
            this.$emit('update:modelValue', value)
            return
          }
        }
      }

      if (!value) {
        this.$emit('update:modelValue', '')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input {
  height: 2.738125rem;
  outline: 0;
  padding: 0.625rem;
  border: 1px solid #EAEAEA;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  line-height: 21.82px;
}
</style>